import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { loadConfig } from './config';
import { Session } from './auth/oidc';
import { createApi } from './api/client';
import { setContext } from './context';
import './style.css';

async function boot() {
  const cfg = await loadConfig();
  const session = new Session(cfg);
  await session.ensureLoggedIn();
  setContext({ cfg, auth: session, api: createApi(cfg.apiBase, session) });
  createApp(App).use(createPinia()).use(router).mount('#app');
}

boot().catch((e: unknown) => {
  const el = document.getElementById('app')!;
  el.innerHTML = '';
  const p = document.createElement('p');
  p.setAttribute('role', 'alert');
  p.className = 'boot-error';
  p.textContent = `peak-ui could not start: ${(e as Error).message}`;
  el.append(p);
});
